const radiusOptions = [
  { distance: '.25 mi', time: '5' },
  { distance: '.5 mi', time: '10' },
  { distance: '1 mi', time: '20' }
];

const WalkRadius = ({ selectedRadius, setSelectedRadius }) => (
  <div className='flex flex-col gap-4 pt-8 pb-4 slide-in-right'>
    {radiusOptions.map((option, index) => (
      <div
        key={index}
        className={`text-white text-lg relative rounded-full p-6 cursor-pointer hover:text-[#ff914d]`}
        onClick={() => setSelectedRadius(String(index + 1))}
      >
        {option.time}-time walk
      </div>
    ))}
  </div>
);

export default WalkRadius;